export default {
    "en": {
        "address": {
            "address_line_1": "Street and number",
            "address_line_2": "Apartment, unit, etc.",
            "city": "City",
            "province": "Province",
            "state": "State",
            "postal_code": "Postal Code",
            "zip_code": "Zip Code",
            "country": "Country",
            "autocomplete": {
                "delivery": {
                    "label": "Deliver to",
                    "placeholder": "Enter your delivery address"
                },
                "pickup": {
                    "label": "Pick up near",
                    "placeholder": "Enter your address to find the closest location"
                }
            },
            "out_of_bound": "Your address is outside of our delivery area, however you can order to pickup in person.",
            "invalid_address": "The selected address is not valid. Please try putting a full address."
        },
        "app": {
            "legal": {
                "privacy": "Privacy Policy",
                "terms": "Terms of Service"
            },
            "required": "Required",
            "optional": "Optional",
            "save": "Save",
            "apply": "Apply"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "Password",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "welcome": "Welcome, {name}",
            "login": "Log In",
            "register": "Sign Up",
            "logout": "Logout",
            "social_login": "Continue with {social_media}",
            "or": "or",
            "name": "Name",
            "first_name": "First Name",
            "last_name": "Last Name",
            "email": "Email Address",
            "email_or_phone": "Email Address or Phone Number",
            "confirm_password": "Confirm Password",
            "forgot_password": "Forgot password",
            "current_password": "Current Password",
            "new_password": "New Password",
            "phone_number": "Phone Number",
            "remember_me": "Remember me",
            "new_user": "Don't have an account?",
            "existing_user": "Already have an account?",
            "almost_there": "You're almost there!",
            "reset_password": "Reset Password",
            "newsletter": "Stay informed with our latest updates, exclusive offers, and promotions! By checking this box, you consent to receive our newsletter and agree to be contacted by email or SMS. You can opt out at any time!",
            "terms_and_conditions": {
                "agree": "I agree to the",
                "and": "and"
            }
        },
        "calendar": {
            "sunday": "Sunday",
            "monday": "Monday",
            "tuesday": "Tuesday",
            "wednesday": "Wednesday",
            "thursday": "Thursday",
            "friday": "Friday",
            "saturday": "Saturday",
            "closed": "Closed"
        },
        "email": {
            "greeting": "Hi {name}",
            "received": "Your order #{id} has been received.",
            "thank_you": "Thank you for ordering from {brand}",
            "pickup": "You can retrieve it on {datetime} at the following address:",
            "delivery": "Your order will be delivered on {datetime} to the following address:",
            "more_details": "More Details →",
            "for_questions": "Should you have any questions regarding this order, please feel free to contact us.",
            "copyright": "All right reserved.",
            "newsletter": {
                "title": "Thank you for subscribing to our newsletter. Here's 15% off just for you!",
                "body": "Don't wait! Use your exclusive offer now, valid online only. Must be signed in to use the promo code",
                "enter_promo_code": "Enter this promo code when placing your order on the website:",
                "use_promo_code": "Use your promo code"
            }
        },
        "home": {
            "slogan": "Changing the world one bowl at a time.",
            "get_social": "Get Social",
            "follow_us": "Follow us on social media to stay updated on our latest promotions!",
            "follow": "Follow {account}",
            "our_favorites": "Our Favorites",
            "view_full_menu": "View Full Menu",
            "newsletter": {
                "header": "Get 15%* off on your next order",
                "incentive": "Subscribe to our newsletter and receive a 15% discount coupon by email!",
                "email": "Email address",
                "placeholder": "Enter your email",
                "action": "Subscribe",
                "fine_print": "* Save 15% on your next online order. Offer valid for the first subscription only. If you are eligible, your discount coupon will be sent to you by email, once your subscription is confirmed.",
                "eligible": {
                    "title": "Thank you for subscribing to our newsletter.",
                    "body": "You will soon receive your welcome offer by email."
                },
                "not_eligible": {
                    "title": "Thank you for subscribing to our newsletter again.",
                    "body": "Since you have already subscribed to the newsletter, you are not eligible for the welcome offer, which is valid for the first subscription only."
                }
            }
        },
        "layout": {
            "app": {
                "language_selector": "Language Selector",
                "open_menu": "Open Menu",
                "navigation": {
                    "menu": "Menu",
                    "find_us": "Find Us",
                    "promotions": "Promotions"
                },
                "order_online": "Order Online"
            },
            "dashboard": {
                "close_sidebar": "Close Side Navigation",
                "navigation": {
                    "home": "Home",
                    "trending": "Trending",
                    "bookmarks": "Bookmarks",
                    "messages": "Messages",
                    "profile": "Profile"
                },
                "account_settings": "Account Settings",
                "open_sidenav": "Open Side Navigation",
                "orders": "Orders"
            },
            "partials": {
                "account_nav": {
                    "account": "Account",
                    "my_orders": "My Orders",
                    "sign_out": "Sign Out",
                    "dashboard": "Dashboard"
                },
                "footer": {
                    "about": "About",
                    "find_us": "Find Us",
                    "jobs": "Jobs",
                    "franchises": "Franchises",
                    "privacy": "Privacy",
                    "terms": "Terms"
                },
                "side_nav": {
                    "close_menu": "Close Menu",
                    "navigation": {
                        "order": "Order",
                        "menu": "Menu",
                        "find_us": "Find Us",
                        "promotions": "Promotions"
                    }
                }
            }
        },
        "location": {
            "business_hours": "Business Hours",
            "get_directions": "Get Directions",
            "closed": "Closed",
            "closing_soon": "Closing Soon",
            "open": "Open",
            "open_at": "Open {datetime}",
            "open_until": "Open until {datetime}",
            "delivery_only": "Delivery Only",
            "pickup_only": "Pickup Only",
            "view_all_locations": "View all locations",
            "store_info": "Store Info",
            "find_us": "Find Us",
            "find_location": "Find a Location",
            "location_search": "Search by address, postal code or city"
        },
        "order": {
            "order": "Order",
            "your_order": "Your order",
            "order_online": "Order Online",
            "choices": "Choices",
            "instructions": "Special Instructions",
            "instructions_placeholder": "e.g. no pepper, no radish",
            "utensil": "Utensil",
            "cart": "Cart",
            "empty_cart": "Looks like your cart is empty!",
            "continue_ordering": "Continue Ordering",
            "start_order": "Start Order",
            "delivery_method": {
                "pickup": "Pick Up",
                "delivery": "Delivery",
                "dine-in": "Dine In",
                "kiosk": "Kiosk"
            },
            "detail": {
                "pickup": "Pick up at",
                "delivery": "Delivering to",
                "when": "When"
            },
            "delivery_time": "Desired Time",
            "delivery_date": "Select a Date",
            "asap": "ASAP",
            "delivery_location": "Select Your Location",
            "bill": {
                "subtotal": "Subtotal",
                "discount": "Discount",
                "delivery_fee": "Delivery Fee",
                "gst": "GST",
                "qst": "QST",
                "hst": "HST",
                "tax": "Tax",
                "tips": "Tips",
                "change_tips": "Change Tips",
                "gift_card": "Gift Card",
                "total": "Total"
            },
            "checkout": "Checkout",
            "order_confirmation": "Order Confirmation",
            "preorder": "Pre-order",
            "preorder_message": "The restaurant is currently <b>closed</b> and will be open at <b>{open_hour}</b>. However, a pre-order can be placed and it'll be delivered or available to be picked up as soon as possible.",
            "complete_order": "To complete your order",
            "place_order": "Place Order",
            "paused": {
                "title": "We are taking a break!",
                "completely": "We are currently not accepting new orders at the chosen location.",
                "delivery": "We are currently not accepting new delivery orders at the chosen location. However you can place an order for pick up.",
                "pickup": "We are currently not accepting new pick up orders at the chosen location. However you can place an order for delivery."
            },
            "coupon": {
                "code": "Coupon Code",
                "success": "The coupon <b>{coupon}</b> has been applied successfully!",
                "error": "The coupon <b>{coupon}</b> is invalid.",
                "removed": "The coupon <b>{coupon}</b> has been removed as it does not meet one or more criteria."
            },
            "gift_card": "Gift Card",
            "gift_card_number": "Gift Card Number",
            "gift_card_balance": "Gift Card Balance",
            "gift_card_success": "The balance remaining on the gift card is <b>{balance}</b>.",
            "gift_card_error": "The gift card number <b>{card_number}</b> is invalid.",
            "gift_card_buy": "Buy eGift Card",
            "gift_card_check_balance": "Check Gift Card Balance",
            "terms": "By clicking \"Place Order\", you are indicating that you have read and agree to {app_name}'s <a class=\"dark-grey-text font-bold\" href=\"/terms\">Terms of Service</a> and <a class=\"dark-grey-text font-bold\" href=\"/privacy\">Privacy Policy</a>.",
            "summary": "Summary",
            "order_details": "Order details",
            "order_summary": "Order Summary",
            "order_number": "Order Number",
            "order_no": "Order #",
            "date": "Date & Time",
            "type": "Type",
            "delivery_address": "Delivery Address",
            "delivery_address_2": "Apt# (Optional)",
            "new_delivery_address": "Add an address",
            "reorder": "Reorder",
            "menu": "Menu",
            "description": "Description",
            "price": "Price",
            "pieces": "pcs",
            "quantity": "Quantity",
            "qty": "Qty",
            "other": "Other",
            "amount": "Amount",
            "minimum_order": "A minimum of {min} is required for delivery"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "payment": {
            "payment_method": "Payment Method",
            "credit_card": "Credit Card",
            "cash": "Cash",
            "pay_at_restaurant": "Pay at the restaurant",
            "paid_by": "Paid by",
            "balance_owed": "Balance Owed",
            "error": "An error has occurred while processing your payment. Please try again later.",
            "expired_card": "Your card is expired. Please contact your financial institution.",
            "card_declined": "Your card was declined by the issuer. Please contact your financial institution."
        },
        "profile": {
            "account_settings": "Account Settings",
            "my_profile": "My Profile",
            "my_profile_description": "This information will help identify your orders.",
            "change_password": "Change Password",
            "change_password_description": "A secure password helps protect your account.",
            "account": {
                "success": {
                    "update": "Your profile has been successfully updated"
                },
                "failure": {
                    "update": "An error has occurred while trying to update your profile"
                }
            },
            "password": {
                "success": {
                    "update": "Your password has been successfully updated"
                },
                "failure": {
                    "update": "An error has occurred while trying to update your password"
                }
            },
            "payment": {
                "success": {
                    "create": "Your payment method has been successfully saved",
                    "update": "Your payment method has been successfully updated",
                    "delete": "Your payment method has been successfully deleted"
                },
                "failure": {
                    "create": "An error has occurred while trying to add your payment method",
                    "update": "An error has occurred while trying to update your payment method",
                    "delete": "An error has occurred while trying to delete your payment method"
                }
            },
            "address": {
                "success": {
                    "create": "Your address has been successfully saved",
                    "update": "Your address has been successfully updated",
                    "delete": "Your address has been successfully deleted"
                },
                "failure": {
                    "create": "An error has occurred while trying to add your address",
                    "update": "An error has occurred while trying to update your address",
                    "delete": "An error has occurred while trying to delete your address"
                }
            }
        },
        "status": {
            "received": "Received",
            "confirmed": "Confirmed",
            "ready": "Ready",
            "completed": "Completed",
            "cancelled": "Cancelled",
            "payment_error": "Payment Error"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal to {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "string": "The {attribute} must be less than or equal to {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    },
    "fr": {
        "address": {
            "address_line_1": "Adresse",
            "address_line_2": "Appartement, unité, etc.",
            "city": "Ville",
            "province": "Province",
            "state": "Etat",
            "postal_code": "Code postal",
            "zip_code": "Zip Code",
            "country": "Country",
            "autocomplete": {
                "delivery": {
                    "label": "Livrer à",
                    "placeholder": "Entrez votre adresse de livraison"
                },
                "pickup": {
                    "label": "Pour emporter proche de",
                    "placeholder": "Entrez votre adresse pour trouver l'emplacement le plus proche"
                }
            },
            "out_of_bound": "Votre adresse se situe en dehors de notre zone de livraison, cependant vous pouvez commander pour emporter en personne.",
            "invalid_address": "L'adresse sélectionnée n'est pas valide. Veuillez entrer une adresse complète."
        },
        "app": {
            "legal": {
                "privacy": "Politique de confidentialité",
                "terms": "Conditions d'utilisation"
            },
            "required": "Requis",
            "optional": "Facultatif",
            "save": "Sauvegarder",
            "apply": "Appliquer"
        },
        "auth": {
            "failed": "Ces identifiants ne correspondent pas à nos enregistrements.",
            "password": "Mot de passe",
            "throttle": "Tentatives de connexion trop nombreuses. Veuillez essayer de nouveau dans {seconds} secondes.",
            "welcome": "Bienvenue, {name}",
            "login": "Se connecter",
            "register": "S'inscrire",
            "logout": "Déconnexion",
            "social_login": "Continuer avec {social_media}",
            "or": "ou",
            "name": "Nom",
            "first_name": "Prénom",
            "last_name": "Nom",
            "email": "Adresse courriel",
            "email_or_phone": "Adresse courriel ou Numéro de téléphone",
            "confirm_password": "Confirmez le mot de passe",
            "forgot_password": "Mot de passe oublié",
            "current_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "phone_number": "Numéro de téléphone",
            "remember_me": "Se souvenir de moi",
            "new_user": "Nouvel utilisateur?",
            "existing_user": "Vous avez déjà un compte?",
            "almost_there": "Vous y êtes presque!",
            "reset_password": "Réinitialiser le mot de passe",
            "newsletter": "Restez informé de nos dernières mises à jour, offres exclusives et promotions ! En cochant cette case, vous acceptez de recevoir notre infolettre et vous acceptez d'être contacté par e-mail ou par SMS. Vous pouvez vous désabonner à tout moment !",
            "terms_and_conditions": {
                "agree": "J'accepte les",
                "and": "et la"
            }
        },
        "calendar": {
            "sunday": "Dimanche",
            "monday": "Lundi",
            "tuesday": "Mardi",
            "wednesday": "Mercredi",
            "thursday": "Jeudi",
            "friday": "Vendredi",
            "saturday": "Samedi",
            "closed": "Fermé"
        },
        "email": {
            "greeting": "Bonjour {name}",
            "received": "Votre commande #{id} a bien été reçue.",
            "thank_you": "Nous vous remercions d'avoir commandé chez {brand}",
            "pickup": "Vous pourrez la récupérer le {datetime} à l'adresse suivante:",
            "delivery": "Votre commande sera livré le {datetime} à l'adresse suivante:",
            "more_details": "Plus de détails →",
            "for_questions": "Si vous avez des questions concernant cette commande, n'hésitez pas à nous contacter.",
            "copyright": "Tous droits réservés.",
            "newsletter": {
                "title": "Merci de vous être abonné à notre infolettre. Voici 15% de réduction juste pour vous!",
                "body": "N'attendez pas! Utilisez dès maintenant votre offre exclusive, valable uniquement en ligne. Vous devez être connecté pour utiliser le code promo",
                "enter_promo_code": "Saisissez ce code promo lorsque vous passez votre commande sur le site web :",
                "use_promo_code": "Utilisez votre code promo"
            }
        },
        "home": {
            "slogan": "Changeons le monde un bol à la fois.",
            "get_social": "Socialisez avec nous",
            "follow_us": "Suivez-nous sur les médias sociaux pour connaître nos plus récentes promotions!",
            "follow": "Suivez {account}",
            "our_favorites": "Nos coups de cœur",
            "view_full_menu": "Menu complet",
            "newsletter": {
                "header": "Obtenez 15%* de réduction sur votre prochaine commande",
                "incentive": "Inscrivez-vous à notre infolettre et recevez un coupon rabais de 15% courriel!",
                "email": "Courriel",
                "placeholder": "Entrez votre courriel",
                "action": "S'inscrire",
                "fine_print": "* Economisez 15% sur votre prochaine commande en ligne. Offre valable uniquement pour le premier abonnement. Si vous êtes éligible, votre coupon rabais vous sera envoyé par email, une fois votre abonnement confirmé.",
                "eligible": {
                    "title": "Merci de vous être abonné à notre infolettre.",
                    "body": "Vous recevrez bientôt votre offre de bienvenue par courriel."
                },
                "not_eligible": {
                    "title": "Merci de vous réabonner à notre infolettre.",
                    "body": "Puisque vous êtes déjà abonné à l'infolettre, vous n'êtes pas éligible à l'offre de bienvenue, valide lors du premier abonnement seulement."
                }
            }
        },
        "layout": {
            "app": {
                "language_selector": "Selection de langue",
                "open_menu": "Ouvrir le menu",
                "navigation": {
                    "menu": "Menu",
                    "find_us": "Nous trouver",
                    "promotions": "Promotions"
                },
                "order_online": "Commande en ligne"
            },
            "dashboard": {
                "close_sidebar": "Fermer la navigation latérale",
                "navigation": {
                    "home": "Accueil",
                    "trending": "Tendances",
                    "bookmarks": "Favoris",
                    "messages": "Messages",
                    "profile": "Profil"
                },
                "account_settings": "Paramètres du compte",
                "open_sidenav": "Ouvrir la navigation latérale",
                "orders": "Commandes"
            },
            "partials": {
                "account_nav": {
                    "account": "Compte",
                    "my_orders": "Mes commandes",
                    "sign_out": "Se déconnecter",
                    "dashboard": "Tableau de bord"
                },
                "footer": {
                    "about": "À propos",
                    "find_us": "Nous trouver",
                    "jobs": "Emplois",
                    "franchises": "Franchises",
                    "privacy": "Confidentialité",
                    "terms": "Conditions d'utilisation"
                },
                "side_nav": {
                    "close_menu": "Fermer le menu",
                    "navigation": {
                        "order": "Commander",
                        "menu": "Menu",
                        "find_us": "Nous trouver",
                        "promotions": "Promotions"
                    }
                }
            }
        },
        "location": {
            "business_hours": "Heures d'ouverture",
            "get_directions": "Obtenir l'itinéraire",
            "closed": "Fermé",
            "closing_soon": "Bientôt fermé",
            "open": "Ouvert",
            "open_at": "Ouvert {datetime}",
            "open_until": "Ouvert jusqu'à {datetime}",
            "delivery_only": "Livraison seulement",
            "pickup_only": "Pour emporter seulement",
            "view_all_locations": "Voir tous les emplacements",
            "store_info": "Info sur l'emplacement",
            "find_us": "Nous trouver",
            "find_location": "Trouver un emplacement",
            "location_search": "Recherche par adresse, code postal ou ville"
        },
        "order": {
            "order": "Commande",
            "your_order": "Votre commande",
            "order_online": "Commande en ligne",
            "choices": "Choix",
            "instructions": "Remarque",
            "instructions_placeholder": "Par ex. pas de poivron, pas de radis",
            "utensil": "Ustensile",
            "cart": "Panier",
            "empty_cart": "On dirait que votre panier est vide!",
            "continue_ordering": "Continuer à commander",
            "start_order": "Commencer la commande",
            "delivery_method": {
                "pickup": "Pour emporter",
                "delivery": "Livraison",
                "dine-in": "Sur place",
                "kiosk": "Kiosque"
            },
            "detail": {
                "pickup": "Ramasser à",
                "delivery": "Livrer à",
                "when": "Quand"
            },
            "delivery_time": "Heure souhaitée",
            "delivery_date": "Sélectionnez une date",
            "asap": "Dès que possible",
            "delivery_location": "Sélectionnez votre emplacement",
            "bill": {
                "subtotal": "Sous-total",
                "discount": "Rabais",
                "delivery_fee": "Frais de livraison",
                "gst": "TPS",
                "qst": "TVQ",
                "hst": "TVH",
                "tax": "Taxes",
                "tips": "Pourboire",
                "change_tips": "Changer le pourboire",
                "gift_card": "Carte-cadeau",
                "total": "Total"
            },
            "checkout": "Commander",
            "order_confirmation": "Confirmation de commande",
            "preorder": "Pré-commander",
            "preorder_message": "Le restaurant est actuellement <b>fermé</b> et sera ouvert à <b>{open_hour}</b>. Cependant, une pré-commande peut être passée et elle sera livrée ou disponible pour être ramassée dès que possible.",
            "complete_order": "Pour compléter votre commande",
            "place_order": "Compléter la commande",
            "paused": {
                "title": "Nous prenons une pause!",
                "completely": "Nous n'acceptons pas de nouvelles commandes pour le moment. Veuillez réessayer plus tard.",
                "delivery": "Nous n'acceptons pas de nouvelles commandes de livraison pour le moment. Cependant, vous pouvez placer une commande pour emporter.",
                "pickup": "Nous n'acceptons pas de nouvelles commandes pour emporter pour le moment. Cependant, vous pouvez placer une commande pour la livraison"
            },
            "coupon": {
                "code": "Coupon rabais",
                "success": "Le coupon rabais <b>{coupon}</b> a été appliqué avec succès!",
                "error": "Le coupon rabais <b>{coupon}</b> est invalide.",
                "removed": "Le coupon rabais <b>{coupon}</b> a été supprimé car il ne répond pas à un ou plusieurs critères."
            },
            "gift_card": "Carte-cadeau",
            "gift_card_number": "Numéro de carte cadeau",
            "gift_card_balance": "Solde de carte-cadeau",
            "gift_card_success": "Le solde restant sur la carte-cadeau est <b>{balance}</b>.",
            "gift_card_error": "Le numéro de carte cadeau <b>{card_number}</b> n'est pas valide.",
            "gift_card_buy": "Acheter une carte-cadeau",
            "gift_card_check_balance": "Vérifiez le solde de carte-cadeau",
            "terms": "En cliquant sur \"Compléter la commande\", vous indiquez que vous avez lu et accepté les <a class=\"dark-grey-text font-bold\" href=\"/terms\">Conditions de service</a> et la <a class=\"dark-grey-text font-bold\" href=\"/privacy\">Politique de confidentialité</a> de {app_name}.",
            "summary": "Sommaire",
            "order_details": "Détails de la commande",
            "order_summary": "Sommaire de la commande",
            "order_number": "Numéro de commande",
            "order_no": "Nº de commande",
            "date": "Date et l'heure",
            "type": "Type",
            "delivery_address": "Adresse de livraison",
            "delivery_address_2": "# d'apt (Optionnel)",
            "new_delivery_address": "Ajouter une adresse",
            "reorder": "Commander à nouveau",
            "menu": "Menu",
            "description": "Description",
            "price": "Prix",
            "pieces": "mcx",
            "quantity": "Quantité",
            "qty": "Qté",
            "other": "Autre",
            "amount": "Montant",
            "minimum_order": "Un minimum de {min} est requis pour la livraison"
        },
        "pagination": {
            "previous": "&laquo; Précédent",
            "next": "Suivant &raquo;"
        },
        "passwords": {
            "reset": "Votre mot de passe a été réinitialisé!",
            "sent": "Nous vous avons envoyé par email le lien de réinitialisation du mot de passe!",
            "throttled": "Veuillez patienter avant de réessayer.",
            "token": "Ce jeton de réinitialisation du mot de passe n'est pas valide.",
            "user": "Aucun utilisateur n'a été trouvé avec cette adresse email."
        },
        "payment": {
            "payment_method": "Mode de paiement",
            "credit_card": "Carte de crédit",
            "cash": "Comptant",
            "pay_at_restaurant": "Payer au restaurant",
            "paid_by": "Payé par",
            "balance_owed": "Solde dû",
            "error": "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer plus tard.",
            "expired_card": "Votre carte est expirée. Veuillez contacter votre institution financière.",
            "card_declined": "Votre carte a été refusée. Veuillez contacter votre institution financière."
        },
        "profile": {
            "account_settings": "Paramètres du compte",
            "my_profile": "Mon profil",
            "my_profile_description": "Ces informations permettront d'identifier vos commandes.",
            "change_password": "Changer le mot de passe",
            "change_password_description": "Un mot de passe sécurisé contribue à protéger votre compte.",
            "account": {
                "success": {
                    "update": "Votre profil a été mis à jour avec succès"
                },
                "failure": {
                    "update": "Une erreur est survenue lors de la mise à jour de votre profil"
                }
            },
            "password": {
                "success": {
                    "update": "Votre mot de passe a été modifié avec succès"
                },
                "failure": {
                    "update": "Une erreur est survenue lors de la mise à jour de votre mot de passe"
                }
            },
            "payment": {
                "success": {
                    "create": "Votre mode de paiement a été enregistré avec succès",
                    "update": "Votre mode de paiement a été mise à jour avec succès",
                    "delete": "Votre mode de paiement a été supprimé avec succès"
                },
                "failure": {
                    "create": "Une erreur est survenue lors de l'ajout de votre mode de paiement",
                    "update": "Une erreur est survenue lors de la mise à jour de votre mode de paiement",
                    "delete": "Une erreur est survenue lors de la suppression de votre mode de paiement"
                }
            },
            "address": {
                "success": {
                    "create": "Votre adresse a été enregistré avec succès",
                    "update": "Votre adresse a été mise à jour avec succès",
                    "delete": "Votre adresse a été supprimé avec succès"
                },
                "failure": {
                    "create": "Une erreur est survenue lors de l'ajout de votre adresse",
                    "update": "Une erreur est survenue lors de la mise à jour de votre adresse",
                    "delete": "Une erreur est survenue lors de la suppression de votre adresse"
                }
            }
        },
        "status": {
            "received": "Reçu",
            "confirmed": "Confirmé",
            "ready": "Prêt",
            "completed": "Complété",
            "cancelled": "Annulé",
            "payment_error": "Erreur de paiement"
        },
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "accepted_if": "Le champ {attribute} doit être accepté quand {other} a la valeur {value}.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure au {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale au {date}.",
            "alpha": "Le champ {attribute} doit contenir uniquement des lettres.",
            "alpha_dash": "Le champ {attribute} doit contenir uniquement des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} doit contenir uniquement des chiffres et des lettres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure au {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale au {date}.",
            "between": {
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments.",
                "file": "La taille du fichier de {attribute} doit être comprise entre {min} et {max} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être comprise entre {min} et {max}.",
                "string": "Le texte {attribute} doit contenir entre {min} et {max} caractères."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "Le champ de confirmation {attribute} ne correspond pas.",
            "current_password": "Le mot de passe est incorrect.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_equals": "Le champ {attribute} doit être une date égale à {date}.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "declined": "Le champ {attribute} doit être décliné.",
            "declined_if": "Le champ {attribute} doit être décliné quand {other} a la valeur {value}.",
            "different": "Les champs {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit contenir entre {min} et {max} chiffres.",
            "dimensions": "La taille de l'image {attribute} n'est pas conforme.",
            "distinct": "Le champ {attribute} a une valeur en double.",
            "email": "Le champ {attribute} doit être une adresse e-mail valide.",
            "ends_with": "Le champ {attribute} doit se terminer par une des valeurs suivantes : {values}",
            "enum": "Le champ {attribute} sélectionné est invalide.",
            "exists": "Le champ {attribute} sélectionné est invalide.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "gt": {
                "array": "Le tableau {attribute} doit contenir plus de {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure à {value}.",
                "string": "Le texte {attribute} doit contenir plus de {value} caractères."
            },
            "gte": {
                "array": "Le tableau {attribute} doit contenir au moins {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure ou égale à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {value}.",
                "string": "Le texte {attribute} doit contenir au moins {value} caractères."
            },
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être un document JSON valide.",
            "lt": {
                "array": "Le tableau {attribute} doit contenir moins de {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être inférieure à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être inférieure à {value}.",
                "string": "Le texte {attribute} doit contenir moins de {value} caractères."
            },
            "lte": {
                "array": "Le tableau {attribute} doit contenir au plus {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être inférieure ou égale à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être inférieure ou égale à {value}.",
                "string": "Le texte {attribute} doit contenir au plus {value} caractères."
            },
            "mac_address": "Le champ {attribute} doit être une adresse MAC valide.",
            "max": {
                "array": "Le tableau {attribute} ne peut contenir plus de {max} éléments.",
                "file": "La taille du fichier de {attribute} ne peut pas dépasser {max} kilo-octets.",
                "numeric": "La valeur de {attribute} ne peut être supérieure à {max}.",
                "string": "Le texte de {attribute} ne peut contenir plus de {max} caractères."
            },
            "mimes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "mimetypes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "min": {
                "array": "Le tableau {attribute} doit contenir au moins {min} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {min} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {min}.",
                "string": "Le texte {attribute} doit contenir au moins {min} caractères."
            },
            "multiple_of": "La valeur de {attribute} doit être un multiple de {value}",
            "not_in": "Le champ {attribute} sélectionné n'est pas valide.",
            "not_regex": "Le format du champ {attribute} n'est pas valide.",
            "numeric": "Le champ {attribute} doit contenir un nombre.",
            "password": "Le mot de passe est incorrect",
            "present": "Le champ {attribute} doit être présent.",
            "prohibited": "Le champ {attribute} est interdit.",
            "prohibited_if": "Le champ {attribute} est interdit quand {other} a la valeur {value}.",
            "prohibited_unless": "Le champ {attribute} est interdit à moins que {other} est l'une des valeurs {values}.",
            "prohibits": "Le champ {attribute} interdit {other} d'être présent.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "Le champ {attribute} est obligatoire quand la valeur de {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {values}.",
            "required_with": "Le champ {attribute} est obligatoire quand {values} est présent.",
            "required_with_all": "Le champ {attribute} est obligatoire quand {values} sont présents.",
            "required_without": "Le champ {attribute} est obligatoire quand {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est requis quand aucun de {values} n'est présent.",
            "same": "Les champs {attribute} et {other} doivent être identiques.",
            "size": {
                "array": "Le tableau {attribute} doit contenir {size} éléments.",
                "file": "La taille du fichier de {attribute} doit être de {size} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être {size}.",
                "string": "Le texte de {attribute} doit contenir {size} caractères."
            },
            "starts_with": "Le champ {attribute} doit commencer avec une des valeurs suivantes : {values}",
            "string": "Le champ {attribute} doit être une chaîne de caractères.",
            "timezone": "Le champ {attribute} doit être un fuseau horaire valide.",
            "unique": "La valeur du champ {attribute} est déjà utilisée.",
            "uploaded": "Le fichier du champ {attribute} n'a pu être téléversé.",
            "url": "Le format de l'URL de {attribute} n'est pas valide.",
            "uuid": "Le champ {attribute} doit être un UUID valide",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
